import { OverviewComponent } from "../components";
import { usePreview } from "./usePreview";

const Preview = (): JSX.Element => {
  const {
    isLoading,
    projectDetails,
    // stackedChartData,
    // xAxisLabels,
    tags,
    badges,
    certifications,
    standardSpecificDefinition,
    restorationUnits,
  } = usePreview();
  return (
    <div>
      {!isLoading && standardSpecificDefinition && (
        <OverviewComponent
          projectDetails={projectDetails}
          // stackedChartData={stackedChartData}
          // xAxisLabels={xAxisLabels}
          tags={tags}
          badges={badges}
          certifications={certifications}
          isPreview
          standardSpecificDefinition={standardSpecificDefinition}
          restorationUnits={restorationUnits}
        />
      )}
    </div>
  );
};

export default Preview;
